export default __webpack_public_path__ + "static/expressive-flat-azul-motion-f436e83697cdeb2e271f52f08128b049.gif";